// test1893
(1893 && 0);
